import type { ReactNode } from 'react';
import { tss } from 'tss-react/mui';
import Collapse from '@mui/material/Collapse';
import { ArrowDownIcon, ArrowRightIcon } from '../icons';
import { getThemeColor } from '../../muiTheme';

const useExpandableStyles = tss.create(({ theme }) => ({
    expandable: {
        display: 'flex',
        alignItems: 'center',
    },
    triggerExpandButton: {
        outline: 0,
        border: 'none',
        backgroundColor: 'transparent',
        padding: 0,
        marginLeft: 10,

        '& > i': {
            color: getThemeColor(theme)('label'),
            cursor: 'pointer',
        },
    },
}));

export default function RootExpandable({
    isOpen,
    onToggle,
    title,
    children,
    disable = false,
}: {
    isOpen: boolean;
    onToggle: () => void;
    title: ReactNode;
    children: ReactNode;
    disable?: boolean;
}) {
    const { classes } = useExpandableStyles();
    return (
        <>
            <div className={classes.expandable}>
                {title}
                {!disable && (
                    <button
                        onClick={onToggle}
                        className={classes.triggerExpandButton}
                    >
                        <i>
                            {isOpen ? (
                                <ArrowDownIcon size={10} />
                            ) : (
                                <ArrowRightIcon size={10} />
                            )}
                        </i>
                    </button>
                )}
            </div>
            {!disable && (
                <Collapse in={isOpen} timeout="auto">
                    {children}
                </Collapse>
            )}
        </>
    );
}
